import { api } from '@/lib/api';
import type {
  AdminBanner,
  BannerListResponse,
  BannerPlacement,
  CreateBannerInput,
  UpdateBannerInput,
} from './types';

export async function fetch_banner_list(
  placement?: BannerPlacement,
  audience?: 'CUSTOMER' | 'VENDOR',
): Promise<BannerListResponse> {
  const res = await api.get<BannerListResponse>('/admin/banners', {
    params: {
      ...(placement ? { placement } : {}),
      ...(audience ? { audience } : {}),
    },
  });
  return res.data;
}

export async function create_banner(input: CreateBannerInput): Promise<AdminBanner> {
  const res = await api.post<AdminBanner>('/admin/banners', input);
  return res.data;
}

export async function update_banner(id: string, input: UpdateBannerInput): Promise<AdminBanner> {
  const res = await api.patch<AdminBanner>(`/admin/banners/${id}`, input);
  return res.data;
}

export async function delete_banner(id: string): Promise<void> {
  await api.delete(`/admin/banners/${id}`);
}

/** Uploads the creative and returns the key to attach to a banner. */
export async function upload_banner_image(file: File): Promise<{ image_s3_key: string }> {
  const form = new FormData();
  form.append('file', file);
  const res = await api.post<{ image_s3_key: string }>('/admin/banners/image', form);
  return res.data;
}
